import { useRef } from 'react';

/**
 * `value`, except while `hold` is set: then the value from the last render without it.
 * Lets derived data stay what was on screen while its source is placeholder data.
 */
export const useHeldWhile = <T>(value: T, hold: boolean): T => {
  const heldRef = useRef(value);
  if (!hold) heldRef.current = value;
  return heldRef.current;
};
